import React, { useState } from "react";
import "./style.css";
import { Typography, Spin, Button, Form, InputNumber } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
// import { createBatch } from "../../../services/batch.service";
const { Title } = Typography;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 18,
    },
  },
};
const config = {
  rules: [
    {
      required: true,
      message: "Please fill out this field.",
    },
  ],
};

const BatchAdd = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = (fieldsValue) => {
    // Should format date value before submit.
    const rangeValue = fieldsValue["range-picker"];
    const rangeTimeValue = fieldsValue["range-time-picker"];
    const values = {
      ...fieldsValue,
      "date-picker": fieldsValue["date-picker"].format("YYYY-MM-DD"),
      batchLevel: fieldsValue["batchLevel"],

      // "range-time-picker": [
      //   rangeTimeValue[0].format("YYYY-MM-DD HH:mm:ss"),
      //   rangeTimeValue[1].format("YYYY-MM-DD HH:mm:ss"),
      // ],
      // "time-picker": fieldsValue["time-picker"].format("HH:mm:ss"),
    };
    // console.log("Received values of form: ", values);
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };

  return (
    <div className="page-content">
      {loading && (
        <div className="pageloader">
          <Spin />
        </div>
      )}
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>Batch Add</Title>
        </div>
        <div className="pch-content">
          <Button>
            <a href="/batch">
              <RollbackOutlined />
            </a>
          </Button>
        </div>
      </div>
      <Form
        name="basic"
        {...formItemLayout}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item name="_id" label="ID" {...config}>
          <InputNumber defaultValue={0} min={1} />
        </Form.Item>
        <Form.Item name="storeId" label="Store Id" {...config}>
          <InputNumber defaultValue={0} min={1} />
        </Form.Item>
        <Form.Item name="zoneId" label="Zone Id" {...config}>
          <InputNumber defaultValue={0} min={1} />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            xs: {
              span: 24,
              offset: 0,
            },
            sm: {
              span: 18,
              offset: 6,
            },
          }}
        >
          <Button htmlType="submit">Submit</Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default BatchAdd;
